import React from "react";
export const repeat = () => {
  return (
    <div className="opinion-wrap">
      <h1>
        对复核意见不服，仍然以同一事实或理由提出诉求的，信访部门或相关职能部门还受理吗？
      </h1>
      <div className="text-cont">
        &nbsp;&nbsp;&nbsp;&nbsp;根据《信访工作条例》第三十六条规定，信访人对复核意见不服，仍然以同一事实和理由提出诉求的，各级党委和各单位信访部门、其他职能部门不再受理。
      </div>
      <br />
    </div>
  );
};
